import { GrFormView } from 'react-icons/gr';
import { BiUpArrowAlt } from 'react-icons/bi';
import { formatCurrency } from '../../../utils/CurrencyUtils';
import Table from '../../../components/lib/table';

const TableCheckbox = ({ checked, onChange }) => (
    <input
        type="checkbox"
        className="w-4 h-4 text-blue-600 bg-gray-100 rounded cursor-pointer"
        checked={checked}
        onChange={onChange}
    />
);

export default function MenuList({
    data,
    itemType,
    selectedItems,
    onSelectAll,
    onSelectItem,
    onSortChange,
    sortField,
    sortDirection,
    onOpenDetails,
    getItemId,
    showSelection = true,
    showQuantity = true
}) {

    const renderSortableLabel = (label, field) => (
        <div
            className="flex justify-center items-center cursor-pointer select-none"
            onClick={() => onSortChange(field)}
        >
            {label}
            {sortField === field && (
                <BiUpArrowAlt
                    className={`ml-2 scale-125 transition-transform ${
                        sortDirection === 'desc' ? 'rotate-180' : ''
                    }`}
                />
            )}
        </div>
    );

    const selectionColumn = {
        key: 'selection',
        label: (
            <TableCheckbox
                checked={data.length > 0 && selectedItems.length === data.length}
                onChange={onSelectAll}
            />
        ),
        render: (item) => (
            <TableCheckbox
                checked={selectedItems.includes(getItemId(item))}
                onChange={() => onSelectItem(getItemId(item))}
            />
        ),
        style: { width: '50px', textAlign: 'center' }
    };

    const activeColumn = {
        key: 'active',
        label: 'Ativo',
        className: "hidden lg:table-cell",
        render: item => (
            <span className={`px-2 py-0.5 rounded text-xs text-white ${
                item.active ? "bg-green-500" : "bg-red-400"
            }`}>
                {item.active ? "Sim" : "Não"}
            </span>
        )
    };

    const columns = [];

    if (showSelection && itemType !== 'Produto') {
        columns.push(selectionColumn);
    }

    columns.push(
        {
            key: 'name',
            label: renderSortableLabel('Nome', 'name')
        },
        {
            key: 'price',
            label: renderSortableLabel('Preço', 'price'),
            render: item => formatCurrency(item.price)
        }
    );

    if (showQuantity) {
        columns.push({
            key: 'quantity',
            label: renderSortableLabel('Disp.', 'quantity')
        });
        columns.push({
            key: 'reserved_quantity',
            // Combo não possui coluna reserved_quantity no backend, então não pode ser ordenado
            label: itemType === 'Combo' ? 'Reservado' : renderSortableLabel('Reservado', 'reserved_quantity'),
            className: 'hidden sm:table-cell',
            render: item => item.reserved_quantity > 0
                ? <span className="px-2 py-0.5 rounded text-xs font-semibold bg-amber-100 text-amber-700 border border-amber-200">{item.reserved_quantity}</span>
                : <span className="text-gray-300">—</span>
        });
    }

    columns.push(
        {
            key: 'category',
            label: renderSortableLabel('Categoria', 'category'),
            className: "hidden lg:table-cell"
        },
        activeColumn
    );

    const renderActions = (item) => (
        <GrFormView
            onClick={() => onOpenDetails(item)}
            className="cursor-pointer text-slate-500 hover:text-blue-600 scale-200 mx-auto"
        />
    );

    return (
        <Table
            columns={columns}
            data={data}
            renderActions={renderActions}
        />
    );
}